import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { motion } from "framer-motion";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import background2 from "../assets/1.png";
import background1 from "../assets/2.png";
import FormComponent from "./FormComponent";


import { useState } from "react";
import { TiDeleteOutline } from "react-icons/ti";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
function Hero() {
 const [offers, setOffers] = useState(null);
 const [isVisible, setIsVisible] = useState(false);
 const navigate=useNavigate();
    const[isContectFormOpen,setIsContactFormOpen]=useState(false);
  useEffect(() => {
    fetch("/offers.json")
      .then((res) => res.json())
      .then((data) => {
        setOffers(data);
        setIsVisible(data?.showPopup ?? false);
      })
      .catch((err) => console.error("Failed to load offers.json:", err));
  }, []);


  
  const openContact=()=>{
    setIsContactFormOpen(!isContectFormOpen);
    setIsVisible(false)
  }
 
  const slides = [
    {
      image: background1,
      title: "Kick start your trading journey with confidence",
      description:
        "Money Doesn't Come Without Guidance, let's Move On with Proficient",
      button: "Book Your Seat Today",
    },
    // {
    //   image: background2,
    //   title: "Innovative Solutions",
    //   description: "Transform Your Trading with Our Analysis",
    //   button: "Get Started",
    // },
  ];
  
  return (
    <div className="">
 {isVisible && offers.image && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="relative w-[90%] max-w-md sm:max-w-xl md:max-w-2xl bg-white rounded-lg shadow-lg overflow-hidden">

            {/* Close Button */}
            <button
              onClick={() => setIsVisible(false)}
              className="absolute top-2 right-2 z-50 text-white hover:text-red-300 transition-colors bg-black bg-opacity-40 rounded-full p-1"
            >
              &times;
            </button>

            {/* Image */}
            <img
              src={offers.image}
              alt="Popup Banner"
              className="w-full h-auto object-cover"
            />

            {/* Contact Us Button (bottom-right overlapping the image) */}
            {offers.contactButton?.enabled && (
              <div className="absolute bottom-4 right-4 z-40">
                <button
                  onClick={() => {
                    setIsVisible(false);
                    navigate('/equity-process');
                  }}
                  className="px-4 py-2 bg-green-600 text-white text-sm sm:text-base rounded-full shadow-md hover:bg-green-700 transition-all font-semibold"
                >
                  {offers.contactButton.label || "Contact Us"}
                </button>
              </div>
            )}
          </div>
        </div>
      )}
      
      <section className="relative z-10">
        <Swiper
          navigation={{
            nextEl: ".swiper-button-next-custom",
            prevEl: ".swiper-button-prev-custom",
          }}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          modules={[Navigation, Autoplay]}
          className="md:h-[85vh] h-auto"
        >
          {slides.map((slide, index) => (
            <SwiperSlide key={index}>
              <div
                className="relative h-full flex flex-col md:flex-row items-center justify-center px-6 md:px-12 lg:px-16 xl:px-24 gap-6"
                style={{
                  backgroundImage: `url(${slide.image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                {/* Overlay for better readability */}
                <div className="absolute inset-0 bg-black/50"></div>

                {/* Left Side Content */}
                <motion.div
                  initial={{ opacity: 0, x: -50 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.8 }}
                  className="relative z-10 w-full md:w-1/2 text-white text-center md:text-left"
                >
                  <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold leading-snug mb-4">
                    {slide.title}
                  </h1>
                  <p className="text-md md:text-lg lg:text-lg mb-6 text-gray-200">
                    {slide.description}
                  </p>
                  <a
                    href="##"
                    className="bg-[#2db928] text-gray-100 hover:bg-[#2db928]/70 py-2 px-5 lg:py-2 lg:px-8 rounded-full text-xs md:text-base lg:text-lg font-semibold transition-transform transform hover:scale-105"
                  >
                    {slide.button}
                  </a>
                </motion.div>

                {/* Right Side Form - Stacks below on small screens */}
                <FormComponent />
              </div>
            </SwiperSlide>
          ))}

          {/* Navigation Buttons */}
          <div className="swiper-button-prev-custom absolute left-4 top-1/2 transform -translate-y-1/2 p-2 rounded-full text-white cursor-pointer z-20">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="md:w-6 md:h-6 lg:w-8 lg:h-8 w-5 h-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15.75 19.5 8.25 12l7.5-7.5"
              />
            </svg>
          </div>
          <div className="swiper-button-next-custom absolute right-4 top-1/2 transform -translate-y-1/2 p-2 rounded-full text-white cursor-pointer z-20">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="md:w-6 md:h-6 lg:w-8 lg:h-8 w-5 h-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m8.25 4.5 7.5 7.5-7.5 7.5"
              />
            </svg>
          </div>
        </Swiper>
      </section>
      {/* {isContectFormOpen && (
        <div className="">
          <FormPopup onClose={openContact}/>
        </div>
      )} */}
    </div>
  );
}

export default Hero;
